/* eslint-disable @typescript-eslint/ban-types */
/**
 * 组件全局变量
 * @class GlobalEvent
 */
class GlobalEvent {
  globalVal: { [key: string]: any } = {}
  #handlers: { [key: string]: Function[] } = {}

  /**
   * 提供全局变量
   * @param key 键
   * @param val 值
   */
  provide(key: string, val: any) {
    this.globalVal[key] = val
    this.publish(key, val)
  }

  /**
   * 发布者
   * @param key 事件名称
   * @param val 值
   */
  publish(key: string, val: any) {
    if(this.#handlers[key]) {
      this.#handlers[key].forEach(handler => {
        handler(val)
      })
    }
  }

  /**
   * 订阅者
   * @param key 事件名称
   * @param handler 值
   */
  subscribe(key: string, handler: Function) {
    if(!this.#handlers[key]) {
      this.#handlers[key] = []
    }

    this.#handlers[key].push(handler)
  }
}

const global = new GlobalEvent()

export default global